export interface DesignVariant {
  name: string;
  // Page background
  bg: string;
  // Header
  headerBg: string;
  headerText: string;
  headerAccent: string;
  headerMuted: string;
  // Mobile card
  mobileCardBg: string;
  mobileCardBorder: string;
  mobileCardShadow: string;
  mobileTitleColor: string;
  mobileSubtitleColor: string;
  mobileTextColor: string;
  mobileMutedColor: string;
  mobilePriceColor: string;
  mobilePriceLabelColor: string;
  mobileDivider: string;
  mobileIconColor: string;
  mobileCtaBg: string;
  mobileCtaText: string;
  mobileCtaHover: string;
  // Desktop card (legacy-style: bg image with overlay content)
  desktopOverlayGradient: string;
  desktopTitleShadow: string;
  desktopCtaBg: string;
  desktopCtaText: string;
  desktopCtaHover: string;
  desktopCtaBorder: string;
}

export const ACTIVE_VARIANT: DesignVariant = {
  // Classic Cream
  name: 'Classic Cream',
  bg: 'bg-[#faf8f6]',
  headerBg: 'bg-white/80 backdrop-blur-md border-b border-[#e8e0d8]',
  headerText: 'text-gray-900',
  headerAccent: 'text-[#801515]',
  headerMuted: 'text-gray-500',
  mobileCardBg: 'bg-white',
  mobileCardBorder: 'border border-[#e8e0d8]',
  mobileCardShadow: 'shadow-md hover:shadow-xl',
  mobileTitleColor: 'text-gray-900',
  mobileSubtitleColor: 'text-[#801515]',
  mobileTextColor: 'text-gray-600',
  mobileMutedColor: 'text-gray-400',
  mobilePriceColor: 'text-[#801515]',
  mobilePriceLabelColor: 'text-gray-500',
  mobileDivider: 'border-[#e8e0d8]',
  mobileIconColor: 'text-[#801515]/70',
  mobileCtaBg: 'bg-[#801515]',
  mobileCtaText: 'text-white',
  mobileCtaHover: 'hover:bg-[#601010]',
  desktopOverlayGradient: 'linear-gradient(to bottom, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.1) 40%, rgba(0,0,0,0.45) 75%, rgba(0,0,0,0.7) 100%)',
  desktopTitleShadow: '3px 2px 10px rgba(0,0,0,0.8)',
  desktopCtaBg: 'bg-white',
  desktopCtaText: 'text-black',
  desktopCtaHover: 'hover:bg-white/90',
  desktopCtaBorder: 'border-none',
};
